var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen grid place-content-center text-center text-black font-bold"},[_c('Spinner'),_c('p',{staticClass:"mt-12"},[_vm._v("Verifying")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }